import axios from "axios";
import { createContext, useContext, useState, useEffect } from "react";
import { url } from "../../../../App";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import Cookies from 'js-cookie';

const BorrowerContext = createContext();

export const useBorrowerContext = () => useContext(BorrowerContext);

export const BorrowerContextProvider = ({ children }) => {
  const Navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [borrowerData, setBorrowerData] = useState({
    borrower: {},
    loan: [],
    coapplicant: [],
    collateral: [],
    cpv: [],
  });

  const updateBorrowerData = (updatedData) => {
    setBorrowerData(updatedData);
  };

  const contextMenuHandler = (e) => {
    e.preventDefault();
  };

  const fetchData = async () => {
    setLoader(true);
    axios
      .post(url + "/user/check/session/v1", {
        token: Cookies.get('Token') === undefined ? "NA" : Cookies.get('Token'),
        email: Cookies.get('Email') === undefined ? "NA" : Cookies.get('Email')
      })
      .then(async (res) => {
        Cookies.set('Token', res.data.token, { expires: 1 });
        try {

          const borrowerReq = {
            token: res.data.token,
            email: Cookies.get('Email'),
            borrower_uniqueno: localStorage.getItem("uniqueID"),
          }
          const { data: borrowerDetails } = await axios.post(url + "/borrower/borrowertoalldetails", borrowerReq)
          if (!borrowerDetails.auth) {
            toast.error(borrowerDetails.message);
            if (borrowerDetails.logout) {
              setTimeout(() => {
                Navigate('/')
              }, 1500);
            }
            setLoader(false);
            return;
          }

          setBorrowerData({
            borrower: borrowerDetails.message.borrower[0],
            loan: borrowerDetails.message.loan,
            coapplicant: borrowerDetails.message.coapplicant,
            collateral: borrowerDetails.message.collateral,
            cpv: borrowerDetails.message.cpv,
            loanTat: borrowerDetails.message.loanTat
          });
        } catch (err) {
          console.log(err)
        } finally {
          setLoader(false)
        }
      })
  }

  useEffect(() => {
    fetchData()
    // eslint-disable-next-line
  }, []);

  return (
    <BorrowerContext.Provider
      value={{ borrowerData, updateBorrowerData, contextMenuHandler, fetchData }}
    >
      {/* <ToastContainer /> */}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {children}
    </BorrowerContext.Provider>
  );
};
